'use es6';

import PropTypes from 'prop-types';
import I18n from 'I18n';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import { getHublVariable } from '../../utils/hubl';
import { LinkTypes, EmailSubscriptionLinkOptions, i18nKey } from '../../constants/link';
import { jsx as _jsx } from "react/jsx-runtime";
const getTranslatedEmailSubscriptionLinkOptions = emailSubscriptionLinkTypes => emailSubscriptionLinkTypes.map(linkType => {
  const {
    text,
    help,
    value
  } = EmailSubscriptionLinkOptions[linkType];
  return {
    text: I18n.text(i18nKey(text)),
    help: I18n.text(i18nKey(help)),
    value
  };
});
export default function EmailSubscriptionLinkField(props) {
  const {
    href,
    onUpdate,
    dropdownClassName,
    emailSubscriptionLinkTypes
  } = props;
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: I18n.text(i18nKey(`linkTypes.${LinkTypes.EMAIL_SUBSCRIPTION}.label`)),
    className: "m-top-0",
    children: /*#__PURE__*/_jsx(UISelect, {
      dropdownClassName: dropdownClassName,
      searchable: true,
      value: getHublVariable(href),
      onSelectedOptionChange: ({
        target: {
          value: data
        }
      }) => {
        onUpdate({
          href: `{{ ${data.value} }}`,
          linkDisplayName: data.text
        });
      },
      options: getTranslatedEmailSubscriptionLinkOptions(emailSubscriptionLinkTypes),
      placeholder: I18n.text(i18nKey(`linkTypes.${LinkTypes.EMAIL_SUBSCRIPTION}.placeholder`))
    })
  });
}
EmailSubscriptionLinkField.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  dropdownClassName: PropTypes.string,
  emailSubscriptionLinkTypes: PropTypes.array.isRequired,
  href: PropTypes.string
};